import { useState } from 'react'
import { oneOfType, node, arrayOf, string, object, bool } from 'prop-types'
import Div from './Div'
import Image from '../elements/Image'
import Link from '../elements/Link'

const Nav = ({
  logo = '',
  logoLink = '',
  logoLinkLabel = '#',
  childrenStart,
  childrenEnd,
  withNavbarBrand = false,
  withMenuToggle = false,
  withNavbarEnd = false,
  cssClass = '',
  otherProps = {},
  role = 'navigation',
  ariaLabel = 'main navigation'
}) => {
  const target = `navabar-${cssClass}`
  const [isActive, setIsActive] = useState(false)
  return (
    <nav className={`navbar ${cssClass}`} role={role} aria-label={ariaLabel} {...otherProps}>
      {withNavbarBrand
        ? <>
          <Div cssClass="navbar-brand">
            <Link cssClass='mission-logo' title={logoLinkLabel} link={logoLink}>
              <Image src={logo} cssFigureClass='logo' />
            </Link>
            {
              withMenuToggle
                ? <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false" data-target={target} onClick={() => setIsActive(!isActive)} >
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </a>
                : <></>
            }

          </Div>
        </>
        : ''
      }

      <Div id={target} cssClass={`navbar-menu ${isActive ? 'is-active' : ''}`}>
        <Div cssClass='navbar-start'>
          {childrenStart}
        </Div>
        {
          withNavbarEnd
            ? <Div cssClass='navbar-end'>
              {childrenEnd}
            </Div>
            : ''
        }
      </Div>
    </nav >
  )
}

Nav.propTypes = {
  logo: string,
  logoLink: string,
  logoLinkLabel: string,
  childrenStart: oneOfType([node, arrayOf(node)]),
  childrenEnd: oneOfType([node, arrayOf(node)]),
  cssClass: string,
  otherProps: object,
  role: string,
  ariaLabel: string,
  withNavbarBrand: bool,
  withNavbarEnd: bool,
  withMenuToggle: bool
}

export default Nav
